import { ErrorTemplate } from "./ErrorTemplate";
import type { ErrorTemplateProps } from "./ErrorTemplateComponent";

export interface PageNotFoundProps extends Omit<
  ErrorTemplateProps,
  "title" | "errorCode"
> {
  errorMessage?: string;
}

/**
 * 404 Error Page
 */
export const PageNotFound = ({
  errorMessage,
  ...passThroughProps
}: PageNotFoundProps) => (
  <ErrorTemplate title={errorMessage} errorCode={404} {...passThroughProps} />
);
